import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../Footer/Footer";
import { NewNavigation } from "../Navigation/NewNavigation";
import { SearchComponent } from "../../components/Search/SearchComponent/SearchComponent";

import { RoutingContext } from "../../Context/Routing.Context";
import { useSearchHook } from "../../Hooks/use-context-hooks";
import Loader from "../../Shared/Components/UI/Loaders/Loader";

import ScrollToTopButton from "../../Shared/Components/UI/ScrollToTopButton/ScrollToTopButton"

import ReactGA from 'react-ga4';
import { logPageView, initializeGA} from "../../Utils/google-analytics";
import WelcomeBar from "../../Shared/Components/UI/WelcomeBar/WelcomeBar";
import FlashMessage from "../../Shared/Components/UI/FlashMessage/FlashMessage";


const RoutingHeader = () => {
  const { isRoutingState, setIsRoutingState } = useContext(RoutingContext)
  const [isFrench, setIsFrench] = useState(false);
  const { isMobileSearchState } = useSearchHook();

  const location = useLocation();
console.log(location)
  // ReactGA.initialize('G-4QM3SEEVKS')
    useEffect(() => {
        initializeGA();
    }, []);
  useEffect(() => {
    // logPageView(location.pathname);
    logPageView(location);
  }, [location]);

  // track changes precisely

  useEffect(() => {
    // window.scrollTo(0, 0);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location]);

  useEffect(() => {
    const language = navigator.language || navigator.userLanguage;
    // console.log('language', language)
    setIsFrench(language.startsWith('fr'));
  }, []);


  // TOTOPBUTTON
  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 800) {
        setIsRoutingState(prevState => ({ ...prevState, isShowScrollToTopButton: true }))
      } else {
        setIsRoutingState(prevState => ({ ...prevState, isShowScrollToTopButton: false }))
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  return (
    <>
      {isRoutingState.isLoading && <Loader />}
      {isRoutingState.isShowScrollToTopButton && <ScrollToTopButton />}
      {
        isMobileSearchState.isMobileSearch &&
        <SearchComponent type='mobile' />
      }
      <>

        <FlashMessage />
        <WelcomeBar />


        <NewNavigation />


        <Footer />
      </>
    </>
  );
};

export default RoutingHeader;
